import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

interface DropZoneProps {
  dragOver: boolean;
}

export const DropZone = styled.div<DropZoneProps>`
  border: ${pxToRem(1)} dashed rgb(114, 82, 220);
  border-radius: ${pxToRem(10)};
  background: rgba(114, 82, 220, 0.17);
  opacity: 0.6;

  width: 100%;
  height: ${pxToRem(150)};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  position: relative;
  margin-bottom: ${pxToRem(24)};

  input {
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  p {
    color: rgb(143, 132, 154);
    font-size: ${pxToRem(16)};
    font-weight: 500;
  }
`;

export const InfoText = styled.div`
  font-size: ${pxToRem(12)};
  color: #888;
  text-align: center;
  margin-bottom: ${pxToRem(10)};
`;

export const FileList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${pxToRem(10)};
  margin-bottom: ${pxToRem(24)};
`;

export const FileItem = styled.div`
  display: flex;
  align-items: center;
  background-color: #f7f8fa;
  border: ${pxToRem(1)} solid #ccc;
  border-radius: ${pxToRem(8)};
  padding: ${pxToRem(4)} ${pxToRem(8)};
  position: relative;
  max-width: ${pxToRem(150)};
`;

export const DownloadableArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${pxToRem(4)};
  margin-right: ${pxToRem(4)};
  cursor: pointer;
  border-radius: ${pxToRem(4)};
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

export const FileIcon = styled.img`
  width: ${pxToRem(20)};
  height: ${pxToRem(20)};
`;

export const SpinnerIconContainer = styled.div`
  position: relative;
  width: ${pxToRem(20)};
  height: ${pxToRem(20)};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SpinnerIcon = styled.div<{ $frames: string[] }>`
  width: ${pxToRem(20)};
  height: ${pxToRem(20)};
  background-image: ${({ $frames }) => $frames.map((frame, index) => `url(${frame})`).join(", ")};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  animation: spinner-animation 0.8s steps(4, end) infinite;
  
  @keyframes spinner-animation {
    0% {
      background-image: url(${({ $frames }) => $frames[0]});
    }
    25% {
      background-image: url(${({ $frames }) => $frames[1]});
    }
    50% {
      background-image: url(${({ $frames }) => $frames[2]});
    }
    75% {
      background-image: url(${({ $frames }) => $frames[3]});
    }
    100% {
      background-image: url(${({ $frames }) => $frames[0]});
    }
  }
`;

export const ProgressPercent = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: ${pxToRem(8)};
  font-weight: 600;
  color: #fff;
  text-shadow: 0 0 ${pxToRem(2)} rgba(0, 0, 0, 0.8);
  z-index: 1;
  pointer-events: none;
`;

export const FileName = styled.span`
  font-size: ${pxToRem(14)};
  color: #333;
  width: ${pxToRem(50)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const RemoveFileButton = styled.button`
  position: absolute;
  top: ${pxToRem(4)};
  right: ${pxToRem(4)};
  background: none;
  border: none;
  color: #ff4d4f;
  font-size: ${pxToRem(16)};
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;
